import { Box, Skeleton, Spacer } from '@bcp-nextgen-dx-component-factory/design-system';
import { AppLayout } from '@components';
import { UIHelper } from '@helpers';

export const LoginSkeletonMobile = () => {
	return (
		<AppLayout>
			<BannerSkeletonMobile />

			<Box
				styles={{
					flex: 1,
					flexDirection: 'column',
					borderTopRightRadius: UIHelper.rem(56),
					zIndex: 1,
					background: '#fff',
					overflowY: 'auto',
				}}
			>
				<Box
					styles={{
						flexDirection: 'column',
						flex: 1,
						padding: UIHelper.rem(48, 24, 48 + 80),
						maxWidth: UIHelper.rem(510),
					}}
				>
					<FormSkeletonMobile />
				</Box>
			</Box>
		</AppLayout>
	);
};

const BannerSkeletonMobile = () => {
	return (
		<Box styles={{ flexDirection: 'column', position: 'relative' }}>
			<Box
				styles={{
					position: 'absolute',
					top: UIHelper.rem(40),
					right: UIHelper.rem(24),
				}}
			></Box>

			<Box
				styles={{
					background: 'linear-gradient(135deg, #d1005d -0.21%, #e3669e 99.79%)',
					flexDirection: 'column',
					padding: UIHelper.rem(40, 24, 32),
					minHeight: UIHelper.rem(246),
				}}
			>
				<Box
					styles={{
						flex: 1,
						flexDirection: 'column',
						justifyContent: 'space-between',
						maxWidth: UIHelper.rem(462),
					}}
				>
					<Box
						styles={{
							flexDirection: 'column',
							gap: UIHelper.rem(40),
						}}
					>
						<Spacer vertical={UIHelper.rem(32)} />

						<Skeleton height={UIHelper.rem(72)} borderRadius={10} variant="dark" />
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

const FormSkeletonMobile = () => (
	<>
		<Skeleton height={UIHelper.rem(32)} borderRadius={10} />
		<Spacer vertical={UIHelper.rem(32)} />
		<Skeleton height={UIHelper.rem(64)} borderRadius={10} />
		<Spacer vertical={UIHelper.rem(32)} />
		<Skeleton height={UIHelper.rem(48)} width={UIHelper.rem(170)} borderRadius={10} />
	</>
);
